<template>
  <div id="app">
    <router-view class="bodyContent"/>
  </div>
</template>
<script>



export default {
  
  created(){
  }
}
</script>
<style lang="scss">
</style>
